
    import './styles.scoped.css';
    export default {
  "wrapper": "awsui_wrapper_z5mul_itasu_9",
  "wrapper--fit-height": "awsui_wrapper--fit-height_z5mul_itasu_42",
  "inner-wrapper--fit-height": "awsui_inner-wrapper--fit-height_z5mul_itasu_47",
  "has-default-filter": "awsui_has-default-filter_z5mul_itasu_53",
  "content": "awsui_content_z5mul_itasu_57",
  "content--reserve-filter": "awsui_content--reserve-filter_z5mul_itasu_64",
  "content--reserve-legend": "awsui_content--reserve-legend_z5mul_itasu_68",
  "content--fit-height": "awsui_content--fit-height_z5mul_itasu_72",
  "filter-container": "awsui_filter-container_z5mul_itasu_76"
};
  